<template>
  <b-container class="mt20">
    <b-modal id="modal-1" title="提示" ok-only no-stacking>
      <p class="my-4">{{resultPrompt}}</p>
    </b-modal>
    <b-row style="display:flex;justify-content: space-between; padding:0 15px;">
      <div>
        <b-breadcrumb :items="bread"></b-breadcrumb>
      </div>
      <div style="margin-top:7px;">
        <b-spinner variant="primary" label="Text Centered" small v-if="loading" style="margin-right:20px"></b-spinner>
        <b-button v-if="false" variant="primary" @click="downLoadWord" class="mr10" size="sm" disabled>下载word</b-button>
        <b-button v-if="false" variant="primary" @click="toGetPdf()" size="sm">下载PDF</b-button>
      </div>
    </b-row>

    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="下载pdf"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
      width="610px"
      content-class="modalclass"
      hide-footer
    >
      等待生成pdf
      <b-button size="sm" variant="outline-danger" @click="$bvModal.hide('modal-prevent-closing')">关闭弹窗</b-button>
      <div id="pdfDom" ref="pdfDom" style="width:570px;height:810px;background-color:#fff;">
        <p
          style="width: 100%;display: block;text-align: center;font-size:22px;font-weight:bold;padding:20px 0 0 0"
        >{{items.cruiseId}}-{{items.cruiseName}}</p>
        <b-table-simple
          style="width:570px;font-size:14px;color:#000;padding:0px 40px 20px 20px;"
          hover
          small
          caption-top
          responsive
          class="mt20"
        >
          <b-tbody>
            <b-tr>
              <b-td class="title-class2">航次编号</b-td>
              <b-td class="title-class2">{{ items.cruiseId }}</b-td>
            </b-tr>
            <b-tr>
              <b-td class="title-class2">航次名称</b-td>
              <b-td class="title-class2">{{ items.cruiseName }}</b-td>
            </b-tr>
            <b-tr>
              <b-td class="title-class2">航次目标</b-td>
              <b-td class="title-class2">{{ items.cruiseAim }}</b-td>
            </b-tr>
            <b-tr>
              <b-td class="title-class2">航次区域</b-td>
              <b-td class="title-class2">{{ items.cruiseArea }}</b-td>
            </b-tr>
            <b-tr>
              <b-td class="title-class2">航次时间</b-td>
              <b-td class="title-class2">{{ items.cruiseTime }}</b-td>
            </b-tr>
            <b-tr>
              <b-td class="title-class2">航次内容</b-td>
              <b-td class="title-class2">{{ items.cruiseContent }}</b-td>
            </b-tr>
            <b-tr>
              <b-td class="title-class2">首席科学家</b-td>
              <b-td class="title-class2">{{ items.cruiseChiefScientist }}</b-td>
            </b-tr>
            <b-tr>
              <b-td class="title-class2">执行单位</b-td>
              <b-td class="title-class2">{{ items.cruiseExecuteUnit }}</b-td>
            </b-tr>
            <b-tr>
              <b-td class="title-class2">执行科考船</b-td>
              <b-td class="title-class2">{{ items.cruiseShip }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </b-modal>

    <b-table-simple hover small caption-top responsive bordered striped class="mt20">
      <b-tbody>
        <b-tr>
          <b-td class="title-class">航次编号</b-td>
          <b-td class="title-class">{{ items.cruiseId }}</b-td>
        </b-tr>
        <b-tr>
          <b-td class="title-class">航次名称</b-td>
          <b-td class="title-class">{{ items.cruiseName }}</b-td>
        </b-tr>
        <b-tr>
          <b-td class="title-class">航次目标</b-td>
          <b-td class="title-class">{{ items.cruiseAim }}</b-td>
        </b-tr>
        <b-tr>
          <b-td class="title-class">航次区域</b-td>
          <b-td class="title-class">{{ items.cruiseArea }}</b-td>
        </b-tr>
        <b-tr>
          <b-td class="title-class">航次时间</b-td>
          <b-td class="title-class">{{ items.cruiseTime }}</b-td>
        </b-tr>
        <b-tr>
          <b-td class="title-class">航次内容</b-td>
          <b-td class="title-class">{{ items.cruiseContent }}</b-td>
        </b-tr>
        <b-tr>
          <b-td class="title-class">首席科学家</b-td>
          <b-td class="title-class">{{ items.cruiseChiefScientist }}</b-td>
        </b-tr>
        <b-tr>
          <b-td class="title-class">执行单位</b-td>
          <b-td class="title-class">{{ items.cruiseExecuteUnit }}</b-td>
        </b-tr>
        <b-tr>
          <b-td class="title-class">执行科考船</b-td>
          <b-td class="title-class">{{ items.cruiseShip }}</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>

    <link-component></link-component>
  </b-container>
</template>

<script>
import LinkComponent from '../../components/LinkComponent.vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';
// import { getPdf } from '@/utils/htmlToPdf';
import { formatDate } from '@/utils/date';

export default {
  components: { LinkComponent },
  name: 'voyage',
  props: {},
  data() {
    return {
      resultPrompt: '',
      bread: [],
      items: '',
      loading: false
    };
  },
  activated() {
    this.requestVoyage();
    this.bread = [
      {
        text: '首页',
        to: '/index'
      },
      {
        text: '共享航次',
        to: '/voyage'
      }
    ];
  },
  mounted() {},
  methods: {
    toGetPdf() {
      this.$refs['modal'].show();

      setTimeout(() => {
        this.getPdf(
          '#pdfDom',
          this.items.cruiseId + '-' + this.items.cruiseName + '-' + formatDate(new Date(), 'yyyyMMdd-hhmmss')
        );
      }, 500);
    },
    requestVoyage() {
      this.loading = true;
      axiosServer({
        url: urls.voyage + '/' + this.$route.query.id
      })
        .then(resp => {
          this.loading = false;
          this.items = resp.data.entity;
          this.bread.push(this.items.cruiseName);
        })
        .catch(e => {
          this.loading = false;
        });
    },
    downLoadWord() {
      axiosServer({
        url: urls.SvpCruiseInfo,
        // params:
        type: 'get'
      }).then(resp => {
        this.showMsg('下载成功');
      });
    },
    downLoadPDF() {
      axiosServer({
        url: urls.SvpCruiseInfo,
        // params:
        type: 'get'
      }).then(resp => {
        this.showMsg('下载成功');
      });
    },
    showMsg(msg) {
      this.resultPrompt = msg;
      this.$bvModal.show('modal-1');
    }
  }
};
</script>


<style>
.modalclass {
  width: 610px;
}
</style>
<style scoped>
.title-class {
  min-width: 120px;
  padding: 10px;
}

.title-class2 {
  min-width: 80px;
  padding: 3px;
}
</style>
